import type { INoteOwner } from './NoteOwner.interface';

export default class NoteOwner implements INoteOwner {
  avatar: string;
  name: string;

  getName() {
    return this.name;
  }

  static build = (data: INoteOwner) => new NoteOwner(data);
  static blank = () => new NoteOwner();

  /**
   * Constructor
   * @param {INoteOwner} data
   */
  constructor(data?: INoteOwner) {
    this.avatar = data?.avatar || undefined;
    this.name = data?.name || undefined;
  }
}
